import { groupsMixin, auth, util } from './groups-mixin';

export const addOrgMixins = {
  mixins: [groupsMixin, auth, util],
  methods: {
    doRegexTest(regex, codeBeingSearched) {
      return regex.test(codeBeingSearched.toLowerCase());
    },
    formattedOrgsToAddString(orgsToAdd) {
      return orgsToAdd.map(orgGroup => orgGroup.displayName).join('  |  ');
    },
    getAvailableOrgMembers(fetchedOrgGroups, currentMemberIds) {
      if (fetchedOrgGroups.length === 0) {
        return fetchedOrgGroups;
      }
      return fetchedOrgGroups.filter(orgGroup =>
        !currentMemberIds.includes(orgGroup.uugid),
      );
    },
    getFilteredAvailableOrgGroups(filterVal, availableOrgGroupMembers) {
      if (this.isEmpty(filterVal)) {
        return availableOrgGroupMembers;
      }
      return availableOrgGroupMembers.filter(orgGroup =>
        orgGroup.uugid.includes(filterVal) ||
        orgGroup.displayName.toLowerCase().includes(filterVal.toLowerCase()));
    },
    getOrgLevel(orgCode) {
      let level = '';
      if (orgCode) {
        if (this.isDepartmentCode(orgCode)) {
          level = 'dept';
        } else if (this.isOrganizationCode(orgCode)) {
          level = 'orgn';
        } else if (this.isManagementCode(orgCode)) {
          level = 'mgmt';
        } else if (this.isSrManagementCode(orgCode)) {
          level = 'srmgmt';
        }
      }
      return level;
    },
    /**
     * Check if the Org being searched (individual org search) is already a member of the current group.
     * */
    isOrgMember(currentOrgMembers, searchedOrgUUGID) {
      const org = currentOrgMembers.find(member => member.uugid === searchedOrgUUGID);
      return !!(org);
    },
    /**
     * Check if provided Organizational Code is Department-Level.
     * Department level codes are 4 digits.
     * @param code provided organizational code to check
     * @returns {boolean}
     */
    isDepartmentCode(code) {
      const departmentRegex = /^[0-9]{4}$/;
      return departmentRegex.test(code);
    },
    /**
     * Check if provided Organizational Code is Organization-Level.
     * Organization (orgn) level codes are 6 alphanumeric strings with length of 6.
     * Valid values are either 6 digits (123456) or 4 digits followed by 2 characters (1234ab)
     * @param code provided organizational code to check
     * @returns {boolean}
     */
    isOrganizationCode(code) {
      /* Organization (orgn) level codes are 6 alphanumeric strings with length of 6.
       * Valid values are either 6 digits (123456) or 4 digits followed by 2 characters (1234ab) */
      const organizationRegex = /^[0-9]{4}[a-z0-9]{2}$/;
      return organizationRegex.test(code.toLowerCase());
    },
    /**
     * Check if provided Organizational Code is Management-Level.
     * Management-level codes are the letter 'm' followed by 3 digits. Ex: m123
     * @param code provided organizational code to check
     * @returns {boolean}
     */
    isManagementCode(code) {
      /* Management (mgmt) level codes are letter m followed by 3 digits. Ex: m123 */
      const managementRegex = /^(m)[0-9]{3}$/;
      return managementRegex.test(code);
    },
    /**
     * Check if provided Organizational Code is Senior Management-Level.
     * Senior Management-Level codes are the letter 's' followed by 2 digits. Ex: s01
     * Regex is checking for letter 's' followed by 2 OR 3 digits in case codes above s99 are added in the future.
     * @param code provided organizational code to check
     * @returns {boolean}
     */
    isSrManagementCode(code) {
      /* Senior Management (srmgmt) level codes are letter s followed by 2 digits (checking for 2 or 3). Ex: s01 */
      const srMgtRegex = /^(s)[0-9]{2,3}$/;
      return srMgtRegex.test(code);
    },
    /**
     * Validate that the provided Organizational Code is in the correct format.
     * @param code provided organizational code to check
     * @returns {boolean}
     */
    isValidOrgCodeFormat(code) {
      return (
        this.isDepartmentCode(code) ||
        this.isOrganizationCode(code) ||
        this.isManagementCode(code) ||
        this.isSrManagementCode(code)
      );
    },
  },
};



// WEBPACK FOOTER //
// ./src/util/add-org-members-mixin.js